module.exports = __webpack_public_path__ + "static/media/block-osu.b93e3367.svg";